import { useMutation, useQueryClient } from "@tanstack/vue-query";
import OrganizationSetting from "@/services/organization/organization-setting";
import type { EditOrganizationSetting } from "@/dtos/OrganizationSetting.dto";

export function useEditOrganizationSetting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: EditOrganizationSetting) => {
      const result = await OrganizationSetting.editOrganizationSetting(payload);

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to edit organization setting");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["organizationSetting"] });
    },
  });
}
